/**
 * Grid rows for one input, built in one pass per row. The previous builder copied the
 * whole row once per period (P² work per row); this keeps its exact output: the same
 * keys in the same order, and the same value wherever a period header shares a name
 * with a row field or a dimension (the row field wins, unless it is the last period).
 */
interface IInputRowsSource {
  ValueHeaders?: string[];
  DimensionHeaders?: { Name: string; Field: string }[];
  Series?: any[];
  FormatKey?: unknown;
  TabName?: string;
}

export const buildInputRows = (
  input: IInputRowsSource | undefined
): Record<string, any>[] =>
  (input?.Series ?? []).map((series) => {
    const valueHeaders = input?.ValueHeaders ?? [];
    const row: Record<string, any> = {};
    if (valueHeaders.length === 0) {
      return row;
    }
    row.Input_RowID = series.Input_RowID;
    row.Group = series.Group;
    row.formatKey = input?.FormatKey;
    row.TabName = input?.TabName;
    row.updatedCells = [];
    (input?.DimensionHeaders ?? []).forEach((dimension) => {
      row[dimension.Name] = series[dimension.Field];
    });
    // Every period but the last was overwritten by the row fields written after it.
    const rowFields = new Set(Object.keys(row));
    const last = valueHeaders.length - 1;
    valueHeaders.forEach((header, i) => {
      if (i === last || !rowFields.has(header)) {
        row[header] = series.Values[i];
      }
    });
    return row;
  });
